'use client';

import { CookiesProvider } from 'react-cookie';
import NextTopLoader from 'nextjs-toploader';
import 'react-loading-skeleton/dist/skeleton.css';
import { SkeletonTheme } from 'react-loading-skeleton';
import { ErrorBoundary } from '@components/ErrorBoundary';
import { AnalyticsProvider } from '@analytics/AnalyticsProvider';
import { ThemeProvider } from '@components/ThemeProvider';
import { Toaster as SonnerToaster } from 'sonner';
import { SessionProvider } from 'next-auth/react';
import { TRPCReactProvider } from '@/trpc/react';
// import { AnalyticsStatsigProviderAppRouter } from '@analytics/AnalyticsStatsigProviderAppRouter';
import { Toaster } from '@components/ui/toaster';
import { Provider as JotaiProvider } from 'jotai';
import { GlobalDialogs } from '@components/GlobalDialogs';
import { CustomerIOProviderAppRouter } from '@analytics/CustomerIOProviderAppRouter';
import { PusherProvider } from '@providers/PusherProvider';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import MyStatsig from '@analytics/AnalyticsStatsigProvider';
import { StatsigUser } from '@statsig/react-bindings';

export function Providers({
  children,
  bootstrapValues,
  statsigUser
}: {
  children: React.ReactNode;
  bootstrapValues?: string;
  statsigUser: StatsigUser;
}) {
  return (
    <JotaiProvider>
      <TRPCReactProvider>
        <ErrorBoundary>
          <SkeletonTheme baseColor="#1c1c1c" highlightColor="#222222" duration={3}>
            <SessionProvider>
              <AnalyticsProvider>
                <MyStatsig values={bootstrapValues || ''} statsigUser={statsigUser}>
                  <PusherProvider>
                    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
                      <CookiesProvider>
                        <NextTopLoader color="#29D" showSpinner={false} />
                        <CustomerIOProviderAppRouter writeKey={process.env.NEXT_PUBLIC_CUSTOMER_IO_WRITE_KEY!}>
                          <NuqsAdapter>{children}</NuqsAdapter>
                        </CustomerIOProviderAppRouter>
                        <GlobalDialogs />
                        <SonnerToaster />
                        <Toaster />
                      </CookiesProvider>
                    </ThemeProvider>
                  </PusherProvider>
                </MyStatsig>
              </AnalyticsProvider>
            </SessionProvider>
          </SkeletonTheme>
        </ErrorBoundary>
      </TRPCReactProvider>
    </JotaiProvider>
  );
}
